// TODO BFH2.0移行は使わないので国庫以外Gum(Zel)関係あるものは全て削除

import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useGumStore = defineStore('gumStore', () => {
  // state
  const gum = ref(0)
  const gumsList = ref([])

  // getters
  const myZel = computed(() => gum.value)
  const myZellsList = computed(() => gumsList.value)

  // actions
  async function fetchGum() {
    // const gum = await this.$nuxt.$gumService.get()
    // this.gum = gum.amount
    // this.gumsList = gum.gumsList
  }

  return {
    gum,
    gumsList,
    myZel,
    myZellsList,
    fetchGum,
  }
})
